import { type FC, type MouseEvent, useState } from "react";

import type { BlockVariantType } from "../../../../shared/types/worksheet";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { PresentPlayBackgroundIcon } from "mds/icons/PresentPlayBackground";
import { useAppSelector } from "store/index";
import { pageSelectors, selectActiveClassSessionId } from "store/selectors";
import { FeatureOptions, featurePage } from "utils/presentation";

export type FeatureButtonProps = FeatureOptions & {
  pageId: string;
  blockType?: BlockVariantType;
};

export const FeatureButton: FC<FeatureButtonProps> = ({ pageId, blockType, ...options }) => {
  const classSessionId = useAppSelector(selectActiveClassSessionId);
  const page = useAppSelector((s) => pageSelectors.selectById(s, pageId));

  const [isHovering, setIsHovering] = useState<boolean>(false);

  const setFeature = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (classSessionId && page) {
      featurePage(classSessionId, page, options);
    }
  };

  return (
    <SquareButton
      eventName="New feature button"
      eventProps={{ blockType }}
      kind={isHovering ? "complete" : "ghost"}
      size="s"
      title={t("presentation.feature")}
      onClick={setFeature}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {isHovering ? (
        <IconText iconStart={<PresentPlayBackgroundIcon />} text={t("presentation.feature")} />
      ) : (
        <PresentPlayBackgroundIcon className="text-green" />
      )}
    </SquareButton>
  );
};
